<template>
    <v-container class="tela">
        <v-row class="mb-lg-12 mt-4 pt-4" justify="center">
                <v-col cols="10" class="text-center">
                    <div class="text-h4 text-md-h3 text">Parabéns!</div>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-lg-12">
                <v-col cols="10" class="text-center mb-0">
                    <v-card color="transparent" flat>
                        <v-card-text>
                            <div class="text-subtitle-1 text-md-h4">
                                <p class="my-0" v-for="p in paragrafos" :key="p">{{p}}</p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="col-sm-10 text-end">
                    <span>{{curso.instrutor}}</span>
                </v-col>
            </v-row>
            <v-row class="d-lg-none" justify="center">
                <v-col class="text-center">
                    <v-btn @click="acessarConteudo()" color="primary">Voltar ao Conteudo</v-btn>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import { baseApiUrl, showError } from "@/config/global"

export default {
    name: 'FinalizacaoCurso',
    props:['curso'],
    computed:{
        ...mapState(['user']),
        paragrafos(){
            let paragrafos = this.curso.texto_conclusao.split(".");
            return paragrafos;
        }
    },
    methods:{
        acessarConteudo(){
            const url = `${baseApiUrl}/estudos/Cursos/buscarProximaAula.php?iniciado=${this.user.user}&curso=${this.curso.id}`;
            let registro;

            axios.get(url).then(res=>{ 
                if(res.data.codigo == "01"){
                    registro = res.data.dados.map(a => {
                        return {
                            data_criacao: a.data_criacao,
                            id: a.id,
                            id_modulo: a.id_modulo,
                            nome: a.nome,
                            tipo: a.tipo,
                            url_video: a.url_video
                        }
                    })
                    registro = registro[0]
                    this.$emit('acessarConteudo', registro)
                }else{
                    showError("Erro ao resgatar conteudo")
                }
            })
        }
    },
}
</script>

<style scoped>
    .nomeInstrutor{
        text-align: right;
    }
</style>